module.exports = __webpack_public_path__ + "img/404.2d90c5b.png";